module.exports = __webpack_public_path__ + "static/toast-criticalaction-do-ad516811de2f866197eb35f41dc40ccf.png";